import { Icon } from 'shared/iconpack'
import { clsx } from 'shared/libs/style-merge'

import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './FAQItem.module.scss'

interface FAQItemProps {
  title: string
  isActive: boolean
}
export function FAQItem({ title, isActive }: FAQItemProps) {
  return (
    <div className={styles.faq}>
      <span className={styles.faqTitle}>{title}</span>
      <Icon
        name="chevronLeft"
        className={clsx(styles.expandIcon, { [styles.expanded]: isActive })}
        color={
          isActive
            ? globalStyles['--icon-sucess']
            : globalStyles['--icon-secondary']
        }
        size={24}
      />
    </div>
  )
}
